/* eslint-disable no-constant-condition */
import { useCallback, useRef } from 'react';

import { Icon } from '../../common/Icon/Icon';
import useModal from '../../core/hooks/useModal';
import { Charger } from '../../core/models';
import ChargerDetails from '../ChargerDetails/ChargerDetails';
import './AdminChargerInfoCard.css';

interface Props {
  onClick: () => void;
  selected: boolean;
  isHot: boolean;
  item: Charger;
  atProperty?: boolean;
}

export function AdminChargerInfoCard({ onClick, selected, isHot, item, atProperty }: Props) {
  const btnRef = useRef(null);
  const { modal, open } = useModal();

  // either we passed a custom action, or this opens its modal
  const clickAction = onClick || open;

  const openModal = useCallback(() => {
    if (!btnRef.current) return;
    open(btnRef.current);
  }, [btnRef.current]);

  return (
    <>
      <div
        className={`admin-info-card${selected ? ` admin-info-card--selected` : ''}${
          isHot ? ' hover' : ''
        }`}
      >
        <button
          className="admin-info-card__modal-btn"
          type="button"
          ref={btnRef}
          onClick={openModal}
        >
          <span className="admin-info-card__title h4">{item.owner.name}</span>
          {false ? (
            <span className="admin-info-card__access_type caption">
              {`${item.access_type} charger`}
            </span>
          ) : null}
          {!atProperty ? (
            <address className="admin-info-card__address caption">{item.address}</address>
          ) : null}
        </button>
        <button className="admin-info-card__select-btn" type="button" onClick={clickAction}>
          <span className="sr-only">Confirm charger {item.owner.name}</span>
          {selected ? (
            <Icon.Checkmark className="icon-small" />
          ) : (
            <Icon.Plus className="icon-small" />
          )}
        </button>
      </div>
      {modal({
        children: <ChargerDetails item={item} atProperty={atProperty} />,
      })}
    </>
  );
}
